<template>
  <b-table
    :items="items"
    :fields="fields.filter((each) => each.selected)"
    :hover="true"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :per-page="0"
    :current-page="currentPage"
    @row-selected="onRowSelected"
    select-mode="single"
    selectable
    label-sort-asc=""
    label-sort-desc=""
    label-sort-clear=""
    sort-icon-right
    show-empty
    :no-border-collapse="true"
    responsive="lg"
    :thead-class="`table-thead text-center bg-transparent ${theadClass}`"
    :tbody-class="`table-tbody text-center ${tbodyClass}`"
    ref="selectableTable"
    info="true"
    class="new-theme-custom-table"
    id="vehicles_table"
  >
    <template #empty> {{ $t("empty-row") }} </template>
    <template #cell(currentGarage)="{ item }">
      <div class="d-flex justify-content-evenly">
        <div v-if="item.img">
          <img :src="require(`@/assets/images/${item.img}.svg`)" />
        </div>
        <div>{{ item.currentGarage }}</div>
      </div>
    </template>

    <template #cell(action)="{ item }">
      <div class="d-flex justify-content-evenly">
        <!-- <div v-if="item.driver">{{ item.driver }}</div>
        <div v-else class="not-assigned-content"></div> -->
        <b-dropdown
          v-if="!disabledEdit || !disabledDelete"
          variant="transparent"
        >
          <div
            class="d-flex flex-column justify-content-center delete-edit-model"
          >
            <div
              id="vehicles_edit_btn"
              v-if="!disabledEdit"
              :class="['d-flex justify-content-center delete-edit-model-text']"
              @mouseenter="EditHovered = true"
              @mouseleave="EditHovered = false"
              @click.stop="moveToEdit(item.id)"
            >
              <img
                :src="
                  EditHovered
                    ? require('@/assets/images/icons/pincle-edit.svg')
                    : require('@/assets/images/icons/pincle-edit.svg')
                "
                alt="edit"
                width="13"
              />
              <p class="text-center my-2 mx-3">{{ $t("edit") }}</p>
            </div>
            <hr class="my-0" />
            <div
              id="vehicles_delete_btn"
              v-if="!disabledDelete"
              class="d-flex justify-content-center delete-edit-model-text"
              @mouseenter="DeleteHovered = true"
              @mouseleave="DeleteHovered = false"
              @click="openDeleteModel(item.id)"
            >
              <img
                :src="
                  DeleteHovered
                    ? require('@/assets/images/icons/trush.svg')
                    : require('@/assets/images/icons/trush.svg')
                "
                alt="delete"
                width="16"
              />
              <p class="text-center my-2 mx-2">{{ $t("delete") }}</p>
            </div>
          </div>
        </b-dropdown>
        <delete-modal
          :id="item.id"
          @refreshData="filterBySideBar"
        ></delete-modal>
      </div>
    </template>

    <template #cell(active)="data">
      <b-button
        :class="[
          'availability-btn',
          data.item.active ? 'availability-btn-true' : 'availability-btn-false',
        ]"
        >{{ data.item.active ? $t("active") : $t("inactive") }}</b-button
      >
    </template>
  </b-table>
</template>

<script>
import DeleteModal from "@/components/Vehicles/listing/deleteModal.vue";

export default {
  props: [
    "tbodyClass",
    "theadClass",
    "items",
    "fields",
    "currentPage",
    "sortByProp",
    "sortDescProp",
  ],
  emits: ["changeParentSorting", "executeFilterBySideBar"],
  components: {
    DeleteModal,
  },
  data() {
    return {
      EditHovered: false,
      sortBy: "",
      sortDesc: false,
      DeleteHovered: false,
    };
  },
  methods: {
    onRowSelected(items) {
      this.$router.push(`/vehicle/${items[0].id}`).catch(() => {});
    },
    moveToEdit(vehicleId) {
      this.$router.push(`/vehicle/edit/${vehicleId}`).catch(() => {});
    },
    filterBySideBar() {
      this.$emit("executeFilterBySideBar");
    },
    openDeleteModel(id) {
      this.$bvModal.show(`delete-vehicle-modal-${id}`);
    },
  },
  computed: {
    disabledEdit() {
      return this.$store.getters["enums/is_not_permitted"]("editVehicle");
    },
    disabledDelete() {
      return this.$store.getters["enums/is_not_permitted"]("deleteVehicle");
    },
  },
  watch: {
    sortBy(val) {
      this.$emit("changeParentSorting", val, this.sortDesc);
    },
    sortDesc(val) {
      this.$emit("changeParentSorting", this.sortBy, val);
    },
    sortByProp(val) {
      this.sortBy = val;
    },
    sortDescProp(val) {
      this.sortDesc = val;
    },
  },
};
</script>
